import mutations from './mutations';
import actions from './actions';

const initialState = {
  loading: false,
  vehicle: {
    license: '',
    VIN: ''
  }
};

const vehicles = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default vehicles;
